module.exports = __webpack_public_path__ + "src/img/cookies/iphone-hand.8efff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/iphone-hand.jpg
// module id = 106
// module chunks = 0